const baseTone = "grey";
const baseContractTone = "white";
const highlightColor = "#bf132a";

export default {
  baseTone,
  baseContractTone,
  highlightColor,
};
